import { getPhotosForMosaic } from 'entities/photos';

Pixlee.module('MosaicApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.numFrames = 1;
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            Show.numFrames = 1;
            this.initialLoad = true;
            var headerView;
            var _this = this;
            var layout = this.getLayout();
            var refCollection = _this.getRefCollection(_this, layout);
            //listen to clicks on load more button
            this.listenTo(layout, 'loadMore', function() {
                Show.numFrames += 1;
                var mosaicMinimum = gon.current_account.id === 1202 ? 3 : 15;
                // verify if there is sufficient photo , else load more if possible
                if (refCollection.length < (Show.numFrames * mosaicMinimum)) {
                    if (refCollection.next) {
                        refCollection.nextPage({
                            success: function() {
                                layout.$el.find('.load_more').removeClass('loading');
                            }
                        });
                    } else {
                        layout.$el.find('.load_more').removeClass('loading');
                        layout.$el.find('.load_more').hide();
                    }
                } else {
                    refCollection.trigger('sync');
                    layout.$el.find('.load_more').removeClass('loading');
                }
            });
            // handle change in display option(CSS gen)
            if (!_.isFalsy(gon.previewMode)) {
                _this = this;
                var header_sponserImage_input;
                App.commands.setHandler('stylesheet:generated', function(css, params) {
                    header_sponserImage_input = header_sponserImage_input || params.header_sponserImage_input;
                    if (!_.isFalsy(params.header_sponserImage_input)) {
                        header_sponserImage_input = params.header_sponserImage_input;
                        App.displayOptions.set('header_sponserImage_input', header_sponserImage_input);
                        headerView = _this.getHeaderView({
                            model: App.currentAlbum
                        });
                        _this.show(headerView, {
                            region: layout.widget_header_region
                        });
                    }
                    Show.numFrames = 1;
                    layout.$el.find('.load_more').removeClass('loading');
                    layout.$el.find('.load_more').show();
                    _this.initialLoad = true;
                    refCollection = _this.getRefCollection(_this, layout);
                    App.displayOptions.set('widget_loadingOption_showHide', !_.isFalsy(params.widget_loadingOption_showHide));
                    layout.triggerMethod('loading:options:change');
                });
            }

            this.listenTo(layout, 'show', function() {
                layout.collection = refCollection;
                headerView = this.getHeaderView({
                    model: App.currentAlbum
                });
                this.show(headerView, {
                    region: layout.widget_header_region
                });
            });
            this.show(layout, {
                loading: true
            });
        },
        getRefCollection: function(_this, layout) {
            var mosaicMinimum = gon.current_account.id === 1202 ? 3 : 15;
            var refCollection = getPhotosForMosaic();
            layout.collection = refCollection;
            refCollection.on('sync', function(collection, resp) {
                if (refCollection.length >= (Show.numFrames - 1) * mosaicMinimum) {
                    var tempCollection = new Backbone.Collection(refCollection.first(Show.numFrames * mosaicMinimum).slice((Show.numFrames - 1) * mosaicMinimum));
                    if (Show.numFrames == 1) {
                        tempCollection = new Backbone.Collection(refCollection.first((Show.numFrames) * mosaicMinimum));
                    }
                    if (tempCollection.length == mosaicMinimum) {
                        var tempRefCollection = _.clone(refCollection);
                        var tempView = _this.getCollectionView({
                            collection: tempCollection,
                            referenceCollection: tempRefCollection
                        });
                        if (Show.numFrames == 1) {
                            if (_this.initialLoad) {
                                layout.frame.show(tempView);
                                _this.initialLoad = false;
                            }
                        } else {
                            layout.frame.append(tempView);
                        }
                    } else if (refCollection.next) {
                        layout.triggerMethod('patch:load:more');
                    } else {
                        layout.$el.find('.load_more').removeClass('loading');
                        layout.$el.find('.load_more').hide();
                    }
                } else {
                    layout.$el.find('.load_more').removeClass('loading');
                    layout.$el.find('.load_more').hide();
                }
                if (_this.widgetloaded) {
                    return false;
                }
                _this.widgetloaded = true;
                gon.sortType = resp.sortType;
                App.commands.execute('opened:photowall', collection.pluck('album_photo_id'), true);
            });
            return refCollection;
        },
        getLayout: function(options) {
            return new Show.Layout(options);
        },
        getCollectionView: function(options) {
            return new Show.MosaicCollection(options);
        },
        getHeaderView: function(options) {
            return new Show.HeaderView(options);
        }
    });

});
